import { create } from 'zustand';
import { LocalStorageUtils } from '@shared/utils';
import { ApiUtils, ProductApi, type Partner } from '@shared/api';

interface UsePartnersStore {
  loading: boolean;
  partners: Partner[] | null;
  selectedPartnerId: number | null;
  error: string | null;
  getPartners: (signal?: AbortSignal) => Promise<void>;
  setPartners: (partners: Partner[]) => void;
  setSelectedPartnerId: (id: number) => void;
  clear: () => void;
}

export const usePartnersStore = create<UsePartnersStore>((set, get) => ({
  loading: false,
  error: null,
  partners: LocalStorageUtils.getPartners(),
  selectedPartnerId: LocalStorageUtils.getSelectedPartnerId(),

  getPartners: async (signal) => {
    try {
      set({ loading: true, error: null });
      const result = await ProductApi.getPartners(signal);
      LocalStorageUtils.setPartners(result);

      let selectedPartnerId = get().selectedPartnerId || 0;
      if (!selectedPartnerId || !result?.some((item) => item.id === selectedPartnerId)) selectedPartnerId = result[0]?.id;
      if (selectedPartnerId) LocalStorageUtils.setSelectedPartnerId(selectedPartnerId);

      set({ loading: false, partners: result ?? null, selectedPartnerId: selectedPartnerId ?? get().selectedPartnerId });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  },

  setPartners: (partners) => set(() => ({ partners })),

  setSelectedPartnerId: (id) => set(() => ({ selectedPartnerId: id })),

  clear: () => set(() => ({ partners: null, selectedPartnerId: null })),
}));
